import { route } from 'quasar/wrappers';
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  createMemoryHistory
} from 'vue-router';
import routes from './routes';
import { registerLandingRouter } from './landing';
import { isElectron } from '@/utils/appUtil';

export default route(() => {
  const isServer = process.env.SERVER;

  // Use hash mode for Electron (file:// protocol), history mode for web
  // Detect Electron by checking if we're in a file:// protocol or if MODE is set
  const isElectronMode = isElectron();
  const createHistory = isServer
    ? createMemoryHistory
    : (isElectronMode ? createWebHashHistory : createWebHistory);


  const Router = createRouter({
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }
      return { left: 0, top: 0 };
    },
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE)
  });

  // Không còn guard `onlyGuest`: cụm màn auth đã công khai (#1028). Việc chặn người CHƯA đăng nhập
  // vẫn do `boot/requireAuth.ts` lo — hai cơ chế độc lập, đừng nhầm.
  // `resolveLandingTarget` cần chính router để hỏi "path này có màn nào nhận không" và "có phải
  // chính điểm vào không". Thiếu dòng này thì hai chốt đó im lặng bị vô hiệu.
  registerLandingRouter(Router);

  return Router;
});
